// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwTabSet from 'viewmodel/AwTabSetViewModel';
import AwCommandBar from 'viewmodel/AwCommandBarViewModel';
import AwSidenav from 'viewmodel/AwSidenavViewModel';
import { VisibleWhen } from 'js/hocCollection';
const DivVisibleWhen = VisibleWhen('div');
const AwFlexColumnVisibleWhen = VisibleWhen(AwFlexColumn);
DivVisibleWhen.displayName = 'DivVisibleWhen';
AwFlexColumnVisibleWhen.displayName = 'AwFlexColumnVisibleWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "sideNavLeftData": {
      "slide": "PUSH",
      "direction": "LEFT_TO_RIGHT",
      "animation": true,
      "width": "STANDARD",
      "height": "FULL"
    },
    "sideNavRightData": {
      "slide": "PUSH",
      "direction": "RIGHT_TO_LEFT",
      "animation": false,
      "width": "WIDE",
      "height": "FULL"
    },
    "buttonCommand": {
      "action": "anAction",
      "iconName": "Add",
      "tooltip": "{{i18n.addSuppliers}}"
    },
    "tabModels": [{
      "name": "Content",
      "tabKey": "contentPage"
    }, {
      "name": "Supplier",
      "tabKey": "supplierPage"
    }],
    "enableRfq": false
  },
  "actions": {
    "openAddSupplierPopup": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "awsidenav.openClose",
          "eventData": {
            "id": "sidenavPushRight",
            "includeView": "AddSupplierCommandPanel",
            "commandId": "sidenavPushCommandRightAddSuppliers"
          }
        }]
      }
    },
    "performOnRfqStatusChangeBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "addRfqStatusToCtx"
      }, {
        "action": "publishUpdateRfqStatusEvent"
      }]
    },
    "addRfqStatusToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfqStatus",
        "value": "{{parameters.eventData}}"
      }
    },
    "publishUpdateRfqStatusEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventName": "rfq-status-changed",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/rfqHelper"
    },
    "openAddContentPopup": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "awsidenav.openClose",
          "eventData": {
            "id": "sidenavPushRight",
            "includeView": "AddContentsCommandPanel",
            "commandId": "sidenavPushCommandRightAddContents"
          }
        }]
      }
    },
    "performOnMountBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "addSessionToCtx"
      }, {
        "action": "addCsIdToCtx"
      }, {
        "action": "addRfqIdToCtx"
      }, {
        "action": "publishUpdateLabelEvent"
      }]
    },
    "publishUpdateLabelEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventName": "updateRfqDetailLabelsConsolidateView"
      },
      "deps": "js/rfqHelper"
    },
    "addSessionToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.accsessionid",
        "value": "{{props.accsessionid}}"
      }
    },
    "addCsIdToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.collaborationspaceid",
        "value": "{{props.collaborationspaceid}}"
      }
    },
    "addRfqIdToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.rfqid",
        "value": "{{props.rfqid}}"
      }
    }
  },
  "onEvent": [{
    "eventId": "rfq-status-event",
    "action": "performOnRfqStatusChangeBatchAction",
    "inputArgs": {
      "eventData": "{{eventData}}"
    },
    "cacheEventData": true
  }, {
    "eventId": "add-contents-rfq-fileUploadSuccess",
    "action": "collab-progress.start",
    "cacheEventData": true
  }, {
    "eventId": "add-contents-rfq.contentAdded",
    "action": "collab-progress.end",
    "cacheEventData": true
  }, {
    "eventId": "add-supplier-event",
    "action": "openAddSupplierPopup",
    "cacheEventData": true
  }, {
    "eventId": "add-content-event",
    "action": "openAddContentPopup",
    "cacheEventData": true
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    }
  },
  "lifecycleHooks": {
    "onMount": "performOnMountBatchAction"
  },
  "conditions": {
    "showContentPage": {
      "expression": "data.selectedTab.tabKey === 'contentPage'"
    },
    "showSupplierPage": {
      "expression": "data.selectedTab.tabKey === 'supplierPage'"
    },
    "enableRfq": {
      "expression": "data.enableRfq"
    }
  },
  "i18n": {
    "addSuppliers": ["RfqMessages"],
    "closedRfqMessage": ["RfqMessages"],
    "awardedRfqMessage": ["RfqMessages"],
    "expiredRfqMessage": ["RfqMessages"]
  },
  "_viewModelId": "ViewRfq",
  "_uniqueViewModelId": "ViewRfq",
  "ctx": {
    "rfqStatus": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <table>
        <tr>
            <des-get-rfq-details
            acc-session-id="{{props.accsessionid}}"
            collaborationspace-id="{{props.collaborationspaceid}}"
            rfq-id="{{props.rfqid}}">
        </des-get-rfq-details>
        </tr>
        <tr>
            <aw-flex-column class="rfqViewColumWidth">
                <aw-flex-row class="rfqViewColumHeight">
                    <aw-flex-column class="rfqViewCommandWidth">
                        <aw-tab-set tabs="data.tabModels">
                            <div visible-when="conditions.showContentPage">
                                <aw-command-bar show-command-labels="true" anchor="showAddContentsCommandAnchor" alignment="HORIZONTAL"></aw-command-bar>
                            </div>
                            <div visible-when="conditions.showContentPage">
                                <des-list-rfq-contents acc-session-id="{{props.accsessionid}}"
                                    collaborationspace-id="{{props.collaborationspaceid}}"
                                    rfq-id="{{props.rfqid}}">
                                </des-list-rfq-contents> 
                            </div>
                            <div visible-when="conditions.showSupplierPage">
                                <aw-command-bar show-command-labels="true" anchor="viewRfqCommandAnchor"
                                    alignment="HORIZONTAL"></aw-command-bar>
                            </div>
                            <div visible-when="conditions.showSupplierPage">
                                <des-list-suppliers-as-list acc-session-id="{{props.accsessionid}}"
                                    collaborationspace-id="{{props.collaborationspaceid}}" rfq-id="{{props.rfqid}}">
                                </des-list-suppliers-as-list>
                            </div>
                        </aw-tab-set>
                    </aw-flex-column>
                    <aw-sidenav id="sidenavPushRight" config="data.sideNavRightData"></aw-sidenav>
                </aw-flex-row>
                <aw-flex-row height="fill">
                    <aw-flex-column width="fill"  visible-when="conditions.showSupplierPage">
                        <des-list-rfq-quote-contents-of-rfq acc-session-id="{{props.accsessionid}}"
                            collaborationspace-id="{{props.collaborationspaceid}}" rfq-id="{{props.rfqid}}">
                        </des-list-rfq-quote-contents-of-rfq>
                        </div>
                    </aw-tab-set>
                    </aw-flex-column>
                    <aw-sidenav id="sidenavPushRight" config="data.sideNavRightData"></aw-sidenav>
                </aw-flex-row>
            </aw-flex-column>
        </tr>
        <tr>
            <div visible-when="ctx.rfqStatus === 'Closed'" class="ax_default ellipse1 rfqPeachMessageBackegroundColor" data-label="Annotation Left Text">
                <div class="text">
                    <br>
                    <ul>
                        <li>&#x2022; {{i18n.closedRfqMessage}}</li>
                    </ul>
                    <br>
                    <br>
                </div>
            </div>
            <div visible-when="ctx.rfqStatus === 'Awarded'" class="ax_default ellipse1 rfqBlueMessageBackegroundColor"
                data-label="Annotation Left Text">
                <div class="text">
                    <br>
                    <ul>
                        <li>&#x2022; {{i18n.awardedRfqMessage}}</li>
                    </ul>
                    <br>
                    <br>
                </div>
            </div>
            <div visible-when="ctx.rfqStatus === 'Expired'" class="ax_default ellipse1 rfqPeachMessageBackegroundColor rfqFontSize"
                data-label="Annotation Left Text">
                <div class="text">
                    <br>
                    <ul>
                        <li>&#x2022; {{i18n.expiredRfqMessage}}</li>
                    </ul>
                    <br>
                    <br>
                </div>
            </div>
        </tr>
    </table>
</div>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("des-get-rfq-details", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-id": AwParseService.instance("props.rfqid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }), /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqViewColumWidth"
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    className: "rfqViewColumHeight"
  }, /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqViewCommandWidth"
  }, /*#__PURE__*/React.createElement(AwTabSet, {
    updateHook: AwParseService.instance("{data, conditions,dispatch }")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    tabs: AwParseService.instance("data.tabModels")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.showContentPage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwCommandBar, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "showAddContentsCommandAnchor",
    alignment: "HORIZONTAL"
  })), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.showContentPage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("des-list-rfq-contents", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-id": AwParseService.instance("props.rfqid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.showSupplierPage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwCommandBar, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "viewRfqCommandAnchor",
    alignment: "HORIZONTAL"
  })), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.showSupplierPage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("des-list-suppliers-as-list", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-id": AwParseService.instance("props.rfqid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })))), /*#__PURE__*/React.createElement(AwSidenav, {
    id: "sidenavPushRight",
    config: AwParseService.instance("data.sideNavRightData")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })), /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "fill"
  }, /*#__PURE__*/React.createElement(AwFlexColumnVisibleWhen, {
    width: "fill",
    visibleWhen: AwParseService.instance("conditions.showSupplierPage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("des-list-rfq-quote-contents-of-rfq", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-id": AwParseService.instance("props.rfqid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })), /*#__PURE__*/React.createElement(AwSidenav, {
    id: "sidenavPushRight",
    config: AwParseService.instance("data.sideNavRightData")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    className: "ax_default ellipse1 rfqPeachMessageBackegroundColor",
    "data-label": "Annotation Left Text",
    visibleWhen: AwParseService.instance("ctx.rfqStatus === 'Closed'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u2022 ", AwParseService.instance("i18n.closedRfqMessage")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    className: "ax_default ellipse1 rfqBlueMessageBackegroundColor",
    "data-label": "Annotation Left Text",
    visibleWhen: AwParseService.instance("ctx.rfqStatus === 'Awarded'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u2022 ", AwParseService.instance("i18n.awardedRfqMessage")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    className: "ax_default ellipse1 rfqPeachMessageBackegroundColor rfqFontSize",
    "data-label": "Annotation Left Text",
    visibleWhen: AwParseService.instance("ctx.rfqStatus === 'Expired'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u2022 ", AwParseService.instance("i18n.expiredRfqMessage")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null), /*#__PURE__*/React.createElement("tr", null), /*#__PURE__*/React.createElement("tr", null))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;